import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, chain, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, chain, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <div className="cart-page__empty-box">
            <h2>Your cart is empty</h2>
            <p>Explore our collection of jewellery!</p>

            <Link
              to="/shop"
              onClick={toTop}
              className="cart-page__continue-btn"
            >
              Continue shopping
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__container">
        <div className="cart-page__left">
          <div className="cart-page__header">
            <h2>CART({cartItems.reduce((sum, item) => sum + item.quantity, 0)})</h2>
            <Link to="/shop" onClick={toTop} className="cart-page__continue-btn">
              CONTINUE SHOPPING
            </Link>
          </div>
          
          <div className="cart-page__items">
            {cartItems.map((item, index) => {
              const product = getProductById(item.id);
              if (!product) return null;
              
              return (
                <div key={`${item.id}-${item.size}-${item.color}-${item.chain}-${index}`} className="cart-page__item">
                  <img src={product.image} alt={product.name} className="cart-page__item-image" />
                  <div className="cart-page__item-details">
                    <h3 className="cart-page__item-name">{product.name}</h3>
                    {item.chain && <p className="cart-page__item-option">Chain Length: {item.chain}</p>}
                    {item.color && <p className="cart-page__item-option">Color: {item.color}</p>}
                  </div>
                  <div className="cart-page__item-price">
                    {product.name.includes("FREE GIFT") ? "Free" : `£${product.price}`}
                  </div>
                  <div className="cart-page__item-quantity">
                    <select
                      value={item.quantity}
                      onChange={(e) => handleUpdateQuantity(item.id, item.size, item.color, item.chain, parseInt(e.target.value))}
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                  </div>
                  <button
                    className="cart-page__item-remove"
                    onClick={() => removeFromCart(item.id, item.size, item.color, item.chain)}
                  >
                    REMOVE
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="cart-page__right">
          <div className="cart-page__subtotal">
            <span>SUBTOTAL</span>
            <span>£{subtotal.toFixed(2)} GBP</span>
          </div>
          <button className="cart-page__checkout" onClick={handleCheckout}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M3 10h18" />
            </svg>
            CHECK OUT
          </button>
          <p className="cart-page__note">Shipping, taxes, and discount codes are calculated at checkout</p>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
